<div class="left-panel">
    <!-- Header: két dropdown -->
    <div class="left-panel__header">
        <div class="left-panel__header-field left-panel__header-field--padded">
            <p-floatlabel variant="in" class="left-panel__full-width">
                <p-select name="categoriesLabels" inputId="categoriesLabels" [options]="categoriesOptions()"
                    [ngModel]="categoriesOptionsLabel()" (ngModelChange)="categoriesOptionsLabel.set($event)" (onChange)="onCategoryTypeChange()"
                    optionLabel="label" optionValue="value" appendTo="body"
                    styleClass="left-panel__header-select left-panel__full-width"></p-select>
                <label for="categoriesLabels">Jogcím típusa</label>
            </p-floatlabel>
        </div>
        <div class="left-panel__header-field left-panel__header-field--padded left-panel__header-field--row">
            <p-floatlabel variant="in" class="left-panel__full-width">
                <p-select name="settlementType" inputId="settlementType" [options]="settlementOptions()"
                    [ngModel]="selectedSettlement()" (ngModelChange)="selectedSettlement.set($event)" (onChange)="onSettlementChange()"
                    [disabled]="voucherIdFilter() !== null"
                    optionLabel="label" optionValue="value" appendTo="body"
                    styleClass="left-panel__header-select left-panel__full-width"></p-select>
                <label for="settlementType">Elszámolás típusa</label>
            </p-floatlabel>
            <button type="button" class="left-panel__refresh-btn" (click)="refreshMatrix()">
                <i class="pi pi-refresh" aria-hidden="true"></i>
            </button>
            <button type="button" class="left-panel__matrix-btn"
                [attr.aria-pressed]="matrixExpanded()" (click)="toggleMatrix()"
                aria-label="Linkelési mátrix">
                <app-svg-icon name="link-matrix" [size]="24" />
            </button>
        </div>
    </div>

    <div class="left-panel__body">
        <!-- Bal oldali szekció: szűrők + fa struktúra -->
        <div class="left-panel__section left-panel__section--left">
            <!-- Szűrők -->
            <div class="left-panel__filters">
                <div class="left-panel__filter-row">
                    <p-iconfield class="left-panel__search">
                        <p-inputicon styleClass="pi pi-search" />
                        <input name="searchText" pInputText type="text" placeholder="Keresés" [(ngModel)]="searchText"
                            class="left-panel__search-input" />
                    </p-iconfield>
                    <div class="left-panel__status-filter left-panel__status-filter--padded">
                        <p-floatlabel variant="in" class="left-panel__full-width">
                            <p-select name="statusFilter" inputId="statusFilter" [options]="statusOptions" [(ngModel)]="selectedStatus"
                                optionLabel="label" optionValue="value"
                                styleClass="left-panel__filter-select left-panel__full-width">
                                <ng-template let-item pTemplate="item">
                                    <div class="left-panel__status-option">
                                        @if (item.color !== 'transparent') {
                                        <span class="left-panel__status-dot" [style.background]="item.color"></span>
                                        }
                                        <span>{{ item.label }}</span>
                                    </div>
                                </ng-template>
                                <ng-template let-item pTemplate="selectedItem">
                                    <div class="left-panel__status-option">
                                        @if (item.color !== 'transparent') {
                                        <span class="left-panel__status-dot" [style.background]="item.color"></span>
                                        }
                                        <span>{{ item.label }}</span>
                                    </div>
                                </ng-template>
                            </p-select>
                            <label for="statusFilter">Feltöltött fájl státusza</label>
                        </p-floatlabel>
                    </div>
                </div>
                <div class="left-panel__checkbox-row left-panel__checkbox-row--flex">
                    <p-checkbox name="onlyMandatory" [(ngModel)]="onlyMandatory" [binary]="true" inputId="onlyMandatory" />
                    <label for="onlyMandatory" class="left-panel__checkbox-label">Csak a kötelezően feltöltendők
                        mutatása</label>
                </div>
                <hr class="left-panel__divider-hr" />
            </div>

            <!-- Fa struktúra -->
            <div #treeWrapper class="left-panel__tree-wrapper"
                (dragover)="onTreeDragOver($event)"
                (dragleave)="onTreeDragLeave($event)"
                (keydown)="onTreeKeydown($event)">
                <p-tree #tree [value]="filteredCategories" selectionMode="single" [selection]="selectedNode()" (selectionChange)="onSelectionChange($event)"
                    (onNodeSelect)="onNodeSelect($event)" (onNodeUnselect)="onNodeUnselect()" class="left-panel__tree" emptyMessage="Nincsenek elemek."
                    [virtualScroll]="true" [virtualScrollItemSize]="40" [scrollHeight]="treeScrollHeight()">
                    <ng-template let-expanded pTemplate="togglericon">
                        <i [class]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            class="left-panel__tree-icon"></i>
                    </ng-template>
                    <ng-template let-node pTemplate="default">
                        <div class="left-panel__node" [class.left-panel__node--group]="node.data?.nodeType === 'group'"
                            [class.left-panel__node--subgroup]="node.data?.nodeType === 'subgroup'"
                            [class.left-panel__node--drop-target]="dragOverItemUuid() === node.data?.uuid"
                            [class.left-panel__node--highlighted]="node.data?.uuid === highlightedItemUuid()"
                            [attr.data-item-uuid]="node.data?.nodeType === 'item' ? node.data?.uuid : null">
                            @if (node.data?.nodeType === 'group' || node.data?.nodeType === 'subgroup') {
                            <i class="pi pi-folder-open left-panel__folder-icon"></i>
                            }
                            <span class="left-panel__node-label" [title]="node.label">{{ node.label }}</span>
                            @if (node.data?.count) {
                            <span class="left-panel__badge">{{ node.data.count }}</span>
                            }
                            @if (node.data?.warning) {
                            <app-svg-icon name="warning-amber" [size]="18"
                                class="left-panel__warning-icon"
                                title="Kötelező melléklet hiányzik" />
                            }
                        </div>
                    </ng-template>
                </p-tree>
            </div>
        </div>

        <!-- Jobb oldali szekció: dropzone + linkelt fájlok, teljes képernyőn a fájlkezelőre váltható -->
        <div class="left-panel__section left-panel__section--right">
            <!-- Teljes képernyős módban a docmatrix fixen marad, a jobb oldali oszlop
                 tartalma viszont kapcsolható: linkelt fájlok vagy a teljes fájlkezelő. -->
            @if (matrixExpanded()) {
            <div class="left-panel__view-switch" role="group" aria-label="Jobb oldali nézet">
                <button type="button" class="left-panel__view-switch-btn"
                    [class.left-panel__view-switch-btn--active]="fullscreenView() === 'linked'"
                    [attr.aria-pressed]="fullscreenView() === 'linked'"
                    (click)="fullscreenView.set('linked')">
                    <i class="pi pi-link" aria-hidden="true"></i>
                    <span>Linkelt fájlok</span>
                </button>
                <button type="button" class="left-panel__view-switch-btn"
                    [class.left-panel__view-switch-btn--active]="fullscreenView() === 'files'"
                    [attr.aria-pressed]="fullscreenView() === 'files'"
                    (click)="fullscreenView.set('files')">
                    <i class="pi pi-folder-open" aria-hidden="true"></i>
                    <span>Fájlkezelő</span>
                </button>
            </div>
            }

            <div class="left-panel__view-pane"
                [class.left-panel__view-pane--hidden]="matrixExpanded() && fullscreenView() === 'files'">
                <app-document-link-area
                    [selectedCategoryLabel]="selectedCategoryLabel()"
                    [selectedCategoryParentLabel]="selectedCategoryParentLabel()"
                    [linkedFiles]="linkedFiles()"
                    (onFilesDropped)="onFilesDropped($event)"
                    (onUnlink)="onFileUnlink($event)"
                    (onMassUnlink)="onMassUnlink($event)"
                    (onNavigate)="navigateToFile.emit($event)"
                    (onPreview)="previewFile.emit($event)" />
            </div>

            <!-- A fájlkezelőt a szülő vetíti be; az ng-content mindig a DOM-ban marad,
                 hogy a projekció ne épüljön újra váltáskor (csak CSS-sel rejtjük). -->
            <div class="left-panel__view-pane"
                [class.left-panel__view-pane--hidden]="!matrixExpanded() || fullscreenView() !== 'files'">
                <ng-content select="[panelFiles]" />
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="left-panel__footer">
        <div class="left-panel__footer-left">
            <div class="left-panel__footer-label">Kötelező mellékletek</div>
            <div class="left-panel__footer-stats">
                <span class="left-panel__footer-count">Feltöltve: {{ branchLinkedCount() }} db / {{ mandatoryTotal() }} db</span>
            </div>
            <div class="left-panel__progress">
                <div class="left-panel__progress-bar" [style.width.%]="mandatoryPercent"></div>
            </div>
            <div class="left-panel__footer-percent">{{ mandatoryPercent }}%</div>
        </div>
        <div class="left-panel__divider"></div>
        <div class="left-panel__footer-right">
            <span>Összesen feltöltött: {{ totalLinkedCount() }} db</span>
        </div>
    </div>

    <app-missing-items-dialog
        [visible]="missingItemsDialogVisible()"
        (visibleChange)="missingItemsDialogVisible.set($event)"
        [items]="missingItems()"
        (navigateToItem)="onNavigateToMissingItem($event)" />

    <app-finalize-confirm-dialog
        [visible]="finalizeConfirmDialogVisible()"
        (visibleChange)="finalizeConfirmDialogVisible.set($event)"
        (finalize)="onFinalizeConfirmed()" />
</div>
